import { AstraHeading, AstraParagraph } from '~/astra'

type Props = {
    unScheduledSurgeriesByPractitionerCount: number
    clearedSurgeriesByPractitionerCount: number
}

export const WaitingListContentHeader = ({ unScheduledSurgeriesByPractitionerCount, clearedSurgeriesByPractitionerCount }: Props) => (
    <div className="flex items-baseline gap-x-2">
        <AstraHeading as="h1">{unScheduledSurgeriesByPractitionerCount}</AstraHeading>
        <AstraParagraph variant="body-small" weight="medium" className="text-muted">
            totalt på venteliste {clearedSurgeriesByPractitionerCount ? `(${clearedSurgeriesByPractitionerCount} klarerte)` : ''}
        </AstraParagraph>
    </div>
)
